import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MDBAnimation, MDBCard, MDBCardBody, MDBRow } from "mdbreact";
import TableLoading from "../../../../components/tableLoading";
import {
  BROWSE,
  HydrateFromAppointments,
} from "../../../../services/redux/slices/diagnostics/clinic/clinicalBilling";
import { ResetBillingDraft } from "../../../../services/redux/slices/diagnostics/clinic/settlements";
import {
  BROWSE as BROWSE_INVENTORY,
  buildInventoryCacheKey,
} from "../../../../services/redux/slices/diagnostics/clinic/clinicInventory";
import "../appointment/transaction/menus/style.css";
import "../../cashier/cashRegistry/services/cashier/style.css";
import BillingHeader from "./header";
import ClientPanel from "./clientPanel";
import CartPanel from "./cartPanel";
import SummaryPanel from "./summaryPanel";

const Billing = () => {
  const dispatch = useDispatch();
  const { token, activePlatform, auth } = useSelector(({ auth }) => auth);
  const {
    selectedAppointmentId = "",
    selectedAppointment = null,
    isLoading,
  } = useSelector(
    ({ clinicalBilling }) => clinicalBilling,
  );
  const { roster: appointmentRoster = [] } = useSelector(
    ({ appointments }) => appointments,
  );
  const {
    collections: inventoryCollections = [],
    lastFetchedAtByClinic = {},
  } = useSelector(({ clinicInventory }) => clinicInventory);

  useEffect(() => {
    if (!token || !activePlatform?.branch) return;

    if (appointmentRoster.length > 0) {
      dispatch(HydrateFromAppointments(appointmentRoster));
      return;
    }

    const physicianIds =
      activePlatform.branch.physicians?.map(({ _id }) => _id).filter(Boolean) ||
      [];
    const secretaryId = auth?._id || "";
    const branchId =
      activePlatform?.branchId || activePlatform?.branch?._id || "";

    if (!secretaryId && !physicianIds.length) return;

    dispatch(
      BROWSE({
        token,
        data: {
          ...(secretaryId ? { secretaryId } : {}),
          ...(branchId ? { branchId } : {}),
          ...(physicianIds.length ? { physicianIds } : {}),
        },
      }),
    );
  }, [dispatch, token, activePlatform, auth, appointmentRoster]);

  useEffect(() => {
    dispatch(ResetBillingDraft());
  }, [dispatch, selectedAppointmentId]);

  useEffect(() => {
    const clinicId =
      selectedAppointment?.clinicId || selectedAppointment?.clinic?._id || "";

    if (!token || !clinicId) return;

    const cacheKey = buildInventoryCacheKey([clinicId]);
    const hasClinicInventory = inventoryCollections.some((item) => {
      const inventoryClinicId = String(
        item?.clinic?._id || item?.clinic || "",
      );
      return inventoryClinicId === String(clinicId);
    });

    if (lastFetchedAtByClinic[cacheKey] && hasClinicInventory) return;

    dispatch(
      BROWSE_INVENTORY({
        token,
        key: { clinicIds: clinicId },
      }),
    );
  }, [
    dispatch,
    token,
    selectedAppointment?.clinicId,
    selectedAppointment?.clinic?._id,
    inventoryCollections,
    lastFetchedAtByClinic,
  ]);

  return (
    <MDBAnimation type="fadeIn">
      <MDBCard narrow className="pb-3">
        <BillingHeader />

        <MDBCardBody>
          {isLoading ? (
            <TableLoading />
          ) : (
            <MDBRow>
              <ClientPanel />
              <CartPanel />
              <SummaryPanel />
            </MDBRow>
          )}
        </MDBCardBody>
      </MDBCard>
    </MDBAnimation>
  );
};

export default Billing;
